import { useQuery } from 'react-query';
import {
  getBettieChatRoomPreferences,
  type GetBettieChatRoomPreferencesResponse
} from '../../services/bettieService';

export function useGetBettieChatRoomPreferences(chatRoomId: string) {
  return useQuery<GetBettieChatRoomPreferencesResponse>(
    ['bettieChatRoomPreferences', chatRoomId],
    () => getBettieChatRoomPreferences(chatRoomId),
    {
      enabled: !!chatRoomId,
      staleTime: 60 * 1000,
      cacheTime: 5 * 60 * 1000
    }
  );
}
